import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BootstrapThemeProp } from '@app/core/services/bootstrap-theme.service';
import { Modal } from '@app/modules/modals/modals.module';
import { faEnvelope, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface ResolverInterface {
    derivedChannelDestination: string;
}

@Component({
    selector: 'fdx-exports-notification-modal',
    templateUrl: './exports-notification-modal.component.html',
    styleUrl: './exports-notification-modal.component.scss',
    standalone: false
})
export class ExportsNotificationModalComponent implements Modal {
    public modalTheme: BootstrapThemeProp = 'secondary';

    readonly iconEnvelope: IconDefinition = faEnvelope;
    resolve: ResolverInterface;

    // eslint-disable-next-line @typescript-eslint/typedef
    public notificationAddressForm = new FormGroup({
        notificationAddress: new FormControl<string>('', [Validators.required])
    });

    get derivedChannelDestination(): string {
        return this.resolve.derivedChannelDestination;
    }

    constructor(
        private readonly modal: NgbActiveModal
    ) { }

    public onModalSubmit(_event: MouseEvent): void {
        if (this.notificationAddressForm.invalid) {
            this.notificationAddressForm.markAllAsTouched();
            return;
        }
        this.modal.close(this.notificationAddressForm.value.notificationAddress);
    }

    public onModalCancel(_event: MouseEvent): void {
        this.modal.dismiss();
    }
}
